/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reserve', {
                parent: 'module',
                url: '/reserve',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRODUCT_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/finishedWarehouse/reserve/reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
